/* Copyright Verge Technologies 2018
 * @file home.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Home Page
 */

// Modules
import React from 'react';

// Components
import Banner from '../../components/Banner/banner';
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import Applications from '../../components/Applications/applications';
import ServicesAndSupport from '../../components/ServicesAndSupport/servicesAndSupport';
import SubscriptionBanner from '../../components/SubscriptionBanner/subscriptionBanner';

const Home = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />
      <Banner />
      <Applications />
      <SubscriptionBanner />
      <ServicesAndSupport />
      <Footer />
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/home.page.js